import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/panda_logo.svg'


const _hoisted_1 = {
  key: 0,
  class: "col-7 header-btn-area q-ml-md"
}
const _hoisted_2 = { class: "account-btn-area" }
const _hoisted_3 = { class: "account-btn" }
const _hoisted_4 = {
  key: 0,
  class: "cmd00001-side-menu"
}

import { ref, provide, readonly } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Loading from 'quasar/src/plugins/Loading.js';;
import { storeToRefs } from 'pinia';
import saveAs from 'file-saver';
import HeaderMenuButton from '../components/button/HeaderMenuButton.vue';
import OrderQuotableButton from '../components/button/OrderQuotableButton.vue';
import AlertDialog from '../components/dialogs/AlertDialog.vue';
import loginUserStore from '../store/loginUserStore';
import http from '../common/axios-common';
import countOrderQuotableKey from '../common/order-quotable-key';
import ResultStatusCode from '../common/code/ResultStatusCode';
import DetailResultStatusCode from '../common/code/DetailResultStatusCode';
import HttpResponseStatusCode from '../common/code/HttpResponseStatusCode';
import MasterMaintenanceMenuList from '../components/list/MasterMaintenanceMenuList.vue';

interface Props {
  // ログイン有無(未ログイン:0、ログイン済み:1[デフォルト値])
  isLogin?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BASE',
  props: {
    isLogin: { default: '1' }
  },
  setup(__props: any) {

const props = __props;

const router = useRouter();

// ユーザーID
const userId = ref<string>('');

// 表示フラグ
const dispFlg = Number(props.isLogin);

// ロゴ遷移先
const logoPath: string = Number(props.isLogin) ? 'top' : 'login';

// 画面遷移先
const getLinks = ref<unknown[]>([]);

// ログアウトダイアログフラグ
const logoutDialogFlg = ref<boolean>(false);

// マニュアルダウンロード失敗フラグ
const downloadDialogFlg = ref<boolean>(false);

// 注文件数
const orderCnt = ref<number>(0);
provide('orderCnt', readonly(orderCnt));

// 問い合わせ件数
const quotableCnt = ref<number>(0);
provide('quotableCnt', readonly(quotableCnt));

// サイドバーを最小化する（trueで最小化）
const miniState = ref(true);

// サイドバーを画面に出すかどうか（マスメン画面の場合に出す）
const ismasterMaintenance = ref(false);

// 最初に開いた画面のパスを格納
const route = ref(useRoute().path);

// ページ再読込で開いた画面がマスメン画面の場合にサイドメニュー表示
if (route.value.indexOf('MasterMaintenance') !== -1) {
  ismasterMaintenance.value = true;
}

// パンチアウト種別
const roleType = ref('');
const poType = ref('');
provide('roleType', readonly(roleType));
provide('poType', readonly(poType));

// マニュアルダウンロード
const download = () => {
  // Loading Start
  Loading.show();
  // パラメータ設定
  const formData = new FormData();
  formData.append('manual_type', 'user');

  // ファイル存在チェック
  http
    .post('/ctp001001/existManualFile', formData)
    .then((response) => {
      switch (response.data.common.status) {
        // 結果ステータス：正常終了
        case ResultStatusCode.SUCCESS:
          switch (response.data.common.detail_status) {
            // 詳細結果ステータス：正常終了
            case DetailResultStatusCode.SUCCESS:
              // マニュアルダウンロード
              saveAs(response.data.path, response.data.fileName);
              break;
            // 詳細結果ステータス：正常終了（メッセージ）
            case DetailResultStatusCode.SUCCESS_MESSAGE:
              // ダイアログ表示
              downloadDialogFlg.value = true;
              break;
            default:
              break;
          }
          break;
        // 結果ステータス：異常終了
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
          break;
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

// TOPへ戻るボタン押下時
const linkToTop = () => {
  ismasterMaintenance.value = false;
  router.push({ name: logoPath });
};

// 会員情報画面へ遷移
const linkToMemberInfo = () => {
  ismasterMaintenance.value = false;
  router.push({ name: 'memberInfo' });
};

// マスターメンテナンス画面を開いたときサイドバーを出す
const openSidebar = () => {
  ismasterMaintenance.value = true;
  miniState.value = true;
};

// ボタン押下でサイドバーが開閉
const clickDrawerBtn = () => {
  miniState.value = !miniState.value;
};

// ログイン情報取得
const getLoginUser = () => {
  const loginUser = loginUserStore();
  const { user_id, role, po_type } = storeToRefs(loginUser);
  http
    .post('/ctp001001/loginUser')
    .then((response) => {
      // 異常終了の場合
      if (response.data.common.status === ResultStatusCode.ERROR) {
        router.push({ name: 'error' });
      } else {
        // ログインユーザー情報をstoreに設定
        loginUser.setLoginUser(response.data.loginUser);
        // ユーザーID設定
        userId.value = user_id.value;
        roleType.value = role.value;
        poType.value = po_type.value;
        // ヘッダー設定
        if (role.value === 'ROLE_ADMIN') {
          // 管理者
          getLinks.value = [
            {
              name: '検索',
              icon: 'mdi-magnify',
              menu: [
                { title: 'キー検索', name: 'search', type: '0' },
                { title: '構造検索', name: 'search', type: '1' },
              ],
            },
            { name: 'カタログデータ', icon: 'mdi-bookshelf', link: 'catalogData' },
            { name: 'お問い合わせ', icon: 'mdi-email-outline', link: 'inquiry' },
            {
              name: '管理',
              icon: 'mdi-cog',
              menu: [
                { title: 'マスタメンテナンス', name: 'masterTop' },
                { title: '会員管理', name: 'members' },
                { title: '注文・見積依頼履歴', name: 'orderQuote' },
                { title: '操作マニュアル（管理者）', name: '' },
              ],
            },
          ];
        } else if (po_type.value === 'PO_ARIBA') {
          // Aribaパンチアウト
          getLinks.value = [
            {
              name: '検索',
              icon: 'mdi-magnify',
              menu: [
                { title: 'キー検索', name: 'search', type: '0' },
                { title: '構造検索', name: 'search', type: '1' },
              ],
            },
          ];
        } else if (po_type.value === 'PO_RE_ARIBA') {
          // 再パンチアウト：チェックアウト以外は表示しない
        } else {
          // 一般ユーザ
          getLinks.value = [
            {
              name: '検索',
              icon: 'mdi-magnify',
              menu: [
                { title: 'キー検索', name: 'search', type: '0' },
                { title: '構造検索', name: 'search', type: '1' },
              ],
            },
            { name: 'お問い合わせ', icon: 'mdi-email-outline', link: 'inquiry' },
          ];
        }
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    });
};

// 注文問い合わせ件数取得
const countOrderQuotable = () => {
  http
    .post('/ctp001001/orderQuotable')
    .then((response) => {
      if (response.data.common.status === ResultStatusCode.ERROR) {
        router.push({ name: 'error' });
      } else {
        orderCnt.value = response.data.orderQuotableItem.order_cnt;
        quotableCnt.value = response.data.orderQuotableItem.quotable_cnt;
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    });
};
provide(countOrderQuotableKey, countOrderQuotable);

// 初期表示処理
// ログインしている場合
if (dispFlg) {
  getLoginUser();
}

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    view: "hHh lpR fFf",
    style: {"min-height":"unset","min-width":"unset"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_header, {
        elevated: "",
        class: "ctp00100-header-primary text-white"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", { class: "ctp00100-logo" }, [
            _createElementVNode("div", {
              class: "logo-area",
              onClick: linkToTop
            }, _cache[7] || (_cache[7] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              }, null, -1)
            ]))
          ]),
          (_unref(dispFlg))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getLinks.value, (link, index) => {
                  return (_openBlock(), _createBlock(HeaderMenuButton, {
                    key: index,
                    link: link,
                    onOpenDialog: _cache[0] || (_cache[0] = ($event: any) => (downloadDialogFlg.value = true)),
                    onOpenSidebar: openSidebar,
                    onDeleteSidebar: _cache[1] || (_cache[1] = ($event: any) => (ismasterMaintenance.value = false))
                  }, null, 8, ["link"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_q_space),
          (_unref(dispFlg))
            ? (_openBlock(), _createBlock(OrderQuotableButton, {
                key: 1,
                "search-result": false,
                class: "q-mr-sm",
                onDeleteSidebar: _cache[2] || (_cache[2] = ($event: any) => (ismasterMaintenance.value = false))
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            (_unref(dispFlg))
              ? (_openBlock(), _createBlock(_component_q_btn, { key: 0 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_q_icon, {
                        class: "account-icon",
                        name: "mdi-account",
                        color: "primary"
                      })
                    ]),
                    _createVNode(_component_q_menu, {
                      "transition-show": "jump-down",
                      "transition-hide": "jump-up",
                      class: "account-menu",
                      style: {"width":"180px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_list, { style: {"min-width":"120px"} }, {
                          default: _withCtx(() => [
                            (poType.value === 'PO_NORMAL')
                              ? (_openBlock(), _createBlock(_component_q_item, {
                                  key: 0,
                                  clickable: "",
                                  onClick: linkToMemberInfo
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_item_section, null, {
                                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                                        _createTextVNode("会員情報")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_q_item, {
                              clickable: "",
                              onClick: download
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, null, {
                                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                                    _createTextVNode("操作マニュアル")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_q_separator),
                            (poType.value === 'PO_NORMAL')
                              ? (_openBlock(), _createBlock(_component_q_item, {
                                  key: 1,
                                  clickable: "",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (logoutDialogFlg.value = true))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_item_section, null, {
                                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                                        _createTextVNode("ログアウト")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_q_page_container, {
        class: _normalizeClass('page-container ' + (ismasterMaintenance.value ? 'mst-mainte' : ''))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view),
          (ismasterMaintenance.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_q_drawer, {
                  "v-model": true,
                  "show-if-above": "",
                  mini: miniState.value,
                  width: 220,
                  breakpoint: 500,
                  bordered: "",
                  persistent: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_scroll_area, { class: "fit mastermaintenance-items" }, {
                      default: _withCtx(() => [
                        _createVNode(MasterMaintenanceMenuList, { mode: "side" })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_btn, {
                      dense: "",
                      unelevated: "",
                      color: "primary",
                      icon: "chevron_left",
                      class: "q-mini-drawer-hide absolute sidebar-btn",
                      onClick: clickDrawerBtn
                    })
                  ]),
                  _: 1
                }, 8, ["mini"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(AlertDialog, {
        display: downloadDialogFlg.value,
        level: "error",
        confirmation: "",
        title: "ダウンロード失敗",
        text: ['操作マニュアルをダウンロードできませんでした。'],
        onComplete: _cache[4] || (_cache[4] = ($event: any) => (downloadDialogFlg.value = false))
      }, null, 8, ["display"]),
      _createVNode(_component_q_dialog, {
        modelValue: logoutDialogFlg.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((logoutDialogFlg).value = $event)),
        persistent: "",
        class: "alertdialog-area"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_toolbar, { class: "information" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_avatar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, { name: "mdi-alert-circle" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_toolbar_title, { class: "text-weight-bold" }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("確認")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode("ログアウトしますか？")
                ])),
                _: 1
              }),
              _createVNode(_component_q_card_actions, {
                align: "right",
                class: "text-primary"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_btn, {
                    color: "primary",
                    label: "OK",
                    href: "/logout"
                  }),
                  _createVNode(_component_q_btn, {
                    outline: "",
                    label: "キャンセル",
                    style: {"color":"var(--q-delete)","margin-left":"12px"},
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (logoutDialogFlg.value = false))
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})